import { render, staticRenderFns } from "./SummaryButton.vue?vue&type=template&id=b83884f8&scoped=true&"
import script from "./SummaryButton.vue?vue&type=script&lang=ts&"
export * from "./SummaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryButton.vue?vue&type=style&index=0&id=b83884f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83884f8",
  null
  
)

export default component.exports